import { buildCompactStatementRow } from './sharedRowFields';

export const adaptProjectGroupedStatement = (statement, transaction) => {
    return buildCompactStatementRow({
        statement,
        transaction,
    });
};

export const adaptProjectGroupedStatements = (transactions = []) => {
    return transactions.flatMap((transaction) =>
        transaction.Statements.map((statement) => adaptProjectGroupedStatement(statement, transaction))
    );
};
